module.exports = __webpack_public_path__ + "img/vizi-graphic.a8e3e6cc.png";